import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { TableHeaderService } from '../table-header.service';

@Component({
  selector: 'tog-table-header-cell',
  templateUrl: './table-header-cell.component.html',
  styleUrls: ['./table-header-cell.component.scss']
})
export class TableHeaderCellComponent implements OnInit {
  @Input() width: string = '';
  @Input() default: boolean = false;
  @Input() sortByAttribute: string;
  @Output() onSort: EventEmitter<string[]> = new EventEmitter();

  id: number;

  constructor(public ths: TableHeaderService, private _el: ElementRef) { }

  ngOnInit() {
    this._el.nativeElement.style.width = this.width; 
    if (this.default) this.sort();
  }

  sort() {
    if (this.sortByAttribute) this.onSort.emit(this.ths.sortColumn(this.sortByAttribute));
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table-header/table-header-cell/table-header-cell.component.ts